import type { ReactNode } from 'react'

export type ColorProps = {
  textClassName?: `text-${string}`
  backgroundClassName?: `bg-${string}`
}

export type InteractivePathPart = ColorProps & {
  label: ReactNode
  href?: string
  onClick?: () => void
}

export type NonInteractivePathPart = ColorProps & {
  label: ReactNode
}

export type PathPart = InteractivePathPart | NonInteractivePathPart

export const isInteractivePathPart = (
  part: PathPart,
): part is InteractivePathPart => 'onClick' in part || 'href' in part
